<template>
  <div :class="['kpi-grid', `kpi-grid-${columns}`]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'KpiGrid',

  props: {
    columns: {
      type: Number,
      default: 3,
      validator: (value) => value >= 1 && value <= 6
    }
  }
}
</script>

<style lang="scss" scoped>
.kpi-grid {
  display: grid;
  gap: 16px;
  width: 100%;

  &-1 {
    grid-template-columns: repeat(1, 1fr);
  }

  &-2 {
    grid-template-columns: repeat(2, 1fr);

    @media (max-width: 767px) {
      grid-template-columns: 1fr;
    }
  }

  &-3 {
    grid-template-columns: repeat(3, 1fr);


    @media (min-width: 1200px) {
      grid-template-columns: repeat(4, 1fr);
    }

    @media (max-width: 767px) {
      grid-template-columns: 1fr;
    }
  }

  &-4 {
    grid-template-columns: repeat(4, 1fr);

    @media (max-width: 1279px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 991px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 767px) {
      grid-template-columns: 1fr;
    }
  }

  &-5,
  &-6 {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
}
</style>
